import React, { memo } from 'react';
import { Badge } from 'react-bootstrap';
import '../../styles/status-badge.css';
import { ContainersOrderStates } from 'shared-pages/shared/constants';
import { useTranslation } from 'react-i18next';

interface BadgeApprovalProps {
  statusId: number | null;
  isApproved: boolean | null;
  className?: string;
}

const BadgeStatusJudgeComponent = ({ statusId, isApproved, className }: BadgeApprovalProps) => {
  const { t } = useTranslation();

  function getColorVariant(statusId: number | null, isApproved: boolean | null): string {
    if (isApproved === null) {
      return 'bg-warning';
    } else if (isApproved === false) {
      return 'bg-danger';
    } else if (isApproved === true) {
      if (statusId === ContainersOrderStates.Pending || statusId === null) {
        return 'bg-primary'; // Blue for 'ΑΝΑΜΟΝΗ'
      } else if (statusId === ContainersOrderStates.Executed) {
        return 'bg-success';
      }
    } else {
      return 'bg-secondary';
    }
  }

  function getBadgeLabel(statusId: number | null, isApproved: boolean | null): string {
    if (isApproved === null) {
      return t('Εκκρεμεί Αξιολόγηση');
    } else if (isApproved === true) {
      if (statusId === null || statusId === ContainersOrderStates.Pending) {
        return t('Εγκρίθηκε - Εκκρεμεί η Παράδοση');
      } else if (statusId === ContainersOrderStates.Executed) {
        return t('Εγκρίθηκε - Ολοκληρώθηκε');
      }
    } else if (isApproved == false) {
      return 'Απορρίφθηκε';
    }
    return '---';
  }

  return (
    <div className={`${className} d-flex justify-content-center  w-full  `}>
      <Badge
        pill={true}
        className={`${getColorVariant(
          statusId,
          isApproved,
        )} badge-status align-middle ps-3 pe-3 text-white`}
      >
        {getBadgeLabel(statusId, isApproved)}
      </Badge>
    </div>
  );
};
export const BadgeStatusJudge = memo(BadgeStatusJudgeComponent);

